import React from "react";
import "./Resume.scss";
import Title from "../../components/Title/Title";
import ResumeCardItem from "./components/resumeCardItem/ResumeCardItem";

const Resume = () => {
  return (
    <div className="resume">
      <Title heading={"Resume"} />
      <div className="page-container resume-inner">
        <div className="row education">
          <h2 data-aos="fade-up-right">Education</h2>
          <ResumeCardItem
            title={"Computer Science"}
            location={"Baku State University"}
            year={"2019 september - 2023 june"}
          />
          <ResumeCardItem
            title={"Software Development"}
            location={"Code Academy"}
            year={"2022 september - 2023 february"}
          />
        </div>
        <div className="row experience">
          <h2 data-aos="fade-up">Experience</h2>
          <ResumeCardItem
            title={"Frontend Instructor"}
            location={"Metalife Groups"}
            year={"2023 april - 2023 august"}
          />
          <ResumeCardItem
            title={"Software Developer"}
            location={"Apollo Digital"}
            year={"2025 august - current"}
          />
        </div>
      </div>
    </div>
  );
};

export default Resume;
